module.exports = __webpack_public_path__ + "img/MochiCoin.c345cfd5.png";